export class MenuLink {
    constructor (
        public id: string,
        public name: string,
        public filter: string = "",
        public tooltip: string = "",
        public link: string = "/report/" + id
     ) {}
}

export class CustomMenuLink {
    constructor (
        public name: string, 
        public link: string,
        public isExternalLink: boolean
     ) {}
}